import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-types',
  templateUrl: './order-types.component.html',
  styleUrls: ['./order-types.component.scss']
})
export class OrderTypesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
